import { Button, Drawer, Label } from "@components";
import { If } from "@components/control-statements";
import styles from "@styles/pages/flow/Flow.module.scss";
import classNames from "classnames/bind";
import { useState } from "react";
const css = classNames.bind(styles);

export const FlowHeaderActions = ({
  flow,
  flowType,
  isValidFlow,
  processingAudience,
  dropdownMenu,
  changesHistoryOpened,
  onReportsClick,
  hasChanges,
  onSave,
  onPreview,
  onRestoreSteps,
  onPublish,
  pointFlow,
}) => {
  // const isValidFlow = true; //FlowBox.isValidFlow(steps?.boxes || [], steps?.links || []);

  const [showOptions, setShowOptions] = useState(false);

  const allowPublish = ["DRAFT", "PAUSED", "PUBLISHED"].includes(flow?.state);

  const save = () => {
    if (allowPublish) setShowOptions(true);
    else onSave && onSave();
  };

  return (
    <div className={styles.flowActions}>
      <If cond={!isValidFlow && hasChanges}>
        <div className={styles.info}>
          <i className="fas fa-exclamation" />
          <p className={styles.message}>
            Existem caixas que ainda não foram devidamente configuradas. Você
            pode configurá-las ou apagá-las.
          </p>
        </div>
      </If>
      {dropdownMenu}
      <If cond={flow && flow.state != "DRAFT"}>
        <Button
          design="default-icon"
          className="mr-15"
          onClick={onReportsClick}
        >
          <i className="fal fa-chart-simple" />
        </Button>
      </If>
      <If cond={!changesHistoryOpened && !["ARCHIVED"].includes(flow?.state)}>
        <If cond={flowType != "EVENT"}>
          <Button
            loading={processingAudience}
            disabled={hasChanges || processingAudience || pointFlow}
            design="two"
            className="mr-15"
            onClick={() => onPreview && onPreview()}
          >
            Calcular público
          </Button>
        </If>
        <Button
          disabled={!isValidFlow || pointFlow || !hasChanges}
          onClick={() => {
            if (isValidFlow && hasChanges) {
              save();
            }
          }}
          design="primary"
        >
          Salvar
        </Button>
      </If>
      <If cond={changesHistoryOpened}>
        <Button design="primary" onClick={onRestoreSteps}>
          Voltar para presente
        </Button>
      </If>

      <Drawer
        title="Salvar"
        visible={showOptions}
        direction="top-alert"
        onClose={() => setShowOptions(false)}
      >
        <div className="d-flex flex-column align-center">
          <Label className="text-center">O que deseja fazer?</Label>
          <div className="mt-20 d-flex justify-center w-100">
            <Button
              design="default-2"
              onClick={() => {
                onSave && onSave();
                setShowOptions(false);
              }}
              className="w-100"
            >
              Apenas salvar
            </Button>
            <Button
              onClick={() => {
                onPublish && onPublish(true);
                setShowOptions(false);
              }}
              className="w-100 ml-15"
              design="primary"
              disabled={!isValidFlow}
            >
              Salvar e publicar
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
};
